import { render } from "./TaskDocumentBanner.vue?vue&type=template&id=54e20168"
import script from "./TaskDocumentBanner.vue?vue&type=script&lang=js"
export * from "./TaskDocumentBanner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__